import { SaleTag } from "interfaces";

export const isSaleActive = (tags: SaleTag[], pageTitle: string): boolean => {
	return (
		typeof tags.find(
			(tag) =>
				tag.showMegaMenuTag && String(tag.megaMenuTagSection) === pageTitle
		) !== "undefined"
	);
};
